import * as React from 'react';

function SvgMore(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="more_svg__clip-path">
          <path
            id="more_svg__Rectangle_373"
            d="M0 0h24v24H0z"
            className="more_svg__cls-1"
            data-name="Rectangle 373"
            transform="translate(315 622)"
          />
        </clipPath>
        <style>{`.more_svg__cls-1{fill:${props.fill}`}</style>
      </defs>
      <g id="more_svg__More" transform="translate(-315 -622)" clipPath="url(#more_svg__clip-path)">
        <g id="more_svg__Group_225" data-name="Group 225" transform="translate(146.756 481.249)">
          <path
            id="more_svg__Path_266"
            d="M171.95 156.163a3.706 3.706 0 113.707-3.706 3.711 3.711 0 01-3.707 3.706zm0-5.651a1.945 1.945 0 101.945 1.945 1.946 1.946 0 00-1.945-1.945z"
            className="more_svg__cls-1"
            data-name="Path 266"
          />
          <path
            id="more_svg__Path_267"
            d="M178.543 156.163a3.706 3.706 0 113.706-3.706 3.711 3.711 0 01-3.706 3.706zm0-5.651a1.945 1.945 0 101.945 1.945 1.947 1.947 0 00-1.945-1.945z"
            className="more_svg__cls-1"
            data-name="Path 267"
            transform="translate(1.701)"
          />
          <path
            id="more_svg__Path_268"
            d="M185.136 156.163a3.706 3.706 0 113.706-3.706 3.711 3.711 0 01-3.706 3.706zm0-5.651a1.945 1.945 0 101.945 1.945 1.946 1.946 0 00-1.945-1.945z"
            className="more_svg__cls-1"
            data-name="Path 268"
            transform="translate(3.402)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgMore;
